import React from 'react';
import PropTypes from 'prop-types';

import settingsReader from '../../store/readHelpers/SettingsReader';
import { t } from '../../services/i18nService';
import navigationService from '../../services/NavigationService';

import styles from './footer.scss';
import sessionReader from '../../store/readHelpers/SessionReader';
import responseReader from '../../store/readHelpers/ResponseReader';
import assessmentReader from '../../store/readHelpers/AssessmentReader';
import branchRuleReader from '../../store/readHelpers/BranchRuleReader';
import uiService from '../../services/UIService';
import ProgressBarContainer from '../progress/ProgressBar';
import footerService from '../../services/FooterService';

class FooterNavButtons extends React.PureComponent {
    static propTypes = {
        currentlyShown: PropTypes.object.isRequired,
        settingValues: PropTypes.object,
        ui: PropTypes.object,
    };

    hasAdditionalResources() {
        return (
            (settingsReader.hasLockdownAdditionalResources() || sessionReader.questionSetHasAdditionalResources())
            && !sessionReader.userHasChromeKiosk()
        );
    }

    showBackButton() {
        const { settingValues } = this.props;

        return (
            settingValues !== undefined
            && settingsReader.allowNavigateBack()
            && !sessionReader.shouldNavigateStrictlySequentially(true)
            && !branchRuleReader.hasBranchRules()
        );
    }

    handleNextButtonClick() {
        footerService.gotoNextTestStep();
    }

    render() {
        const { ui, currentlyShown } = this.props;
        const { footer__navIcon: navIcon } = ui.variables;
        const hiddenTrackClass = !settingsReader.showAssessmentTrack() || branchRuleReader.hasBranchRules() ? 'nav-buttons--withouttrack' : '';
        const additionalResourcesClass = this.hasAdditionalResources() ? 'nav-buttons--withadditionalresources' : '';
        const rubricClass = footerService.hasRubricToDisplay(currentlyShown.questionId) ? 'questionHasRubric' : '';
        const className = `${styles.navButtons} ${hiddenTrackClass} ${additionalResourcesClass} ${rubricClass}`;
        const useArrowIcon = navIcon === 'arrow';
        const question = assessmentReader.getQuestion(currentlyShown.questionId);
        const isQuestionDone = !!question && responseReader.isQuestionDone(question);
        const isPromoteNextButtonOnDoneEnabled = settingsReader.isPromoteNextButtonOnDoneEnabled();
        const nextButtonClasses = [];

        if (!isQuestionDone && isPromoteNextButtonOnDoneEnabled) {
            nextButtonClasses.push(styles.demotedNextBtn);
        } else {
            nextButtonClasses.push(styles.promotedNextBtn);
        }

        if (isQuestionDone && isPromoteNextButtonOnDoneEnabled) {
            nextButtonClasses.push(styles.shakeButtonOnPageDone);
        }

        if (useArrowIcon) {
            nextButtonClasses.push(styles.arrowIconBtn);
        }

        return (
            <div
                className={className}
                role="navigation"
                aria-label={t('navigation.controlsTitle')}
                id="footer-nav-wrapper"
                tabIndex="-1"
            >
                { settingsReader.isProgressBarQuestionsEnabled() && <ProgressBarContainer {...this.props} /> }

                { this.showBackButton() &&
                    <button
                        className={`${styles.previousBtn} ${useArrowIcon ? styles.arrowIconBtn : ''}`}
                        disabled={uiService.disabledPreviousButton()}
                        id="footer-nav-button-previous"
                        onClick={navigationService.navigateToPreviousStep}
                        aria-label={t('navigation.previous')}
                    >
                        <i className={`fa fa-${navIcon}-left`} aria-hidden="true" />
                    </button>
                }

                <button
                    className={nextButtonClasses.join(' ')}
                    disabled={uiService.disabledNextButton()}
                    id="footer-nav-button-next"
                    aria-label={t('navigation.next')}
                    onClick={this.handleNextButtonClick}
                >
                    <i className={`fa fa-${navIcon}-right`} aria-hidden="true" />
                </button>
            </div>
        );
    }
}

export default FooterNavButtons;
